import React, { useState } from "react";
import ForgotPassword from "./ForgotPassword";
import useRTLContext from "../../../../hooks/useRTLContext";
import { useTranslation } from "react-i18next";

const AccountSettings = () => {
  const [paymentSettings, setPaymentSettings] = useState(true);
  const [announcementsUpdates, setAnnouncementsAndUpdates] = useState(false);
  const [emailAnnouncemnets, setEmailAnnouncements] = useState(true);
  const [communicationEmails, setCommunicationEmails] = useState(false);
    const { isRTL, direction } = useRTLContext();
  const { t, i18n } = useTranslation();

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="min-h-screen bg-[#F9FAFB] p-4 md:p-8 text-black">
            <div className="max-w-full mx-auto">
              {/* Header */}
              <div className="border-[1px] border-[#EAECF0] rounded-md mb-4 p-4 md:p-6">
                <h1 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">
                  {t("Account Settings")}
                </h1>
                <p className="text-[#475467] text-sm md:text-base">
                  {t(`Keep track of all your Account Updates in one centralized place for better organization and decision-making.`)}
                </p>
              </div>

              {/* Notification Setting Section */}
              <div className="bg-[#F9FAFB] border-[1px] border-[#EAECF0] rounded-md text-black">
                <div className="bg-[#F9FAFB] p-4 md:p-6 rounded-lg">
                  <h2 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">
                    {t("Notification Settings")}
                  </h2>
                  <p className="text-[#475467] text-sm md:text-base mb-4 md:mb-6">
                    {t(`Customize your notification preferences to stay updated. Enable or disable alerts for emails, SMS, and in-app notifications based on your needs.`)}
                  </p>
                </div>

                {/* Toggle Sections */}
                <div className="divide-y divide-[#EAECF0]">
                  <div className="p-4 md:p-6 flex flex-col md:flex-row md:justify-between md:items-center gap-4">
                    <div className="flex-1">
                      <h2 className="text-lg md:text-xl font-semibold mb-2 md:mb-4">
                        {t("Payment")}
                      </h2>
                      <p className="text-[#475467] text-sm md:text-base mb-4 md:mb-0">
                        {t(`When you've been paid or need to be notified to keep your Wave Payments operating.`)}
                      </p>
                    </div>
                    <button
                      onClick={() => setPaymentSettings(!paymentSettings)}
                      className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors ${
                        paymentSettings ? "bg-[#1A6D73]" : "bg-gray-500"
                      }`}
                    >
                      <div
                        className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform ${
                          paymentSettings ? "translate-x-6" : "translate-x-0"
                        }`}
                      ></div>
                    </button>
                  </div>

                  <div className="p-4 md:p-6 flex flex-col md:flex-row md:justify-between md:items-center gap-4">
                    <div className="flex-1">
                      <h2 className="text-lg md:text-xl font-semibold mb-2 md:mb-4">
                        {t("Announcements & Updates")}
                      </h2>
                      <p className="text-[#475467] text-sm md:text-base mb-4 md:mb-0">
                        {t(`Receive email about service updates, Improvements & Tickets, etc.`)}
                      </p>
                    </div>
                    <button
                      onClick={() =>
                        setAnnouncementsAndUpdates(!announcementsUpdates)
                      }
                      className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors ${
                        announcementsUpdates ? "bg-[#1A6D73]" : "bg-gray-500"
                      }`}
                    >
                      <div
                        className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform ${
                          announcementsUpdates
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </button>
                  </div>
                </div>
              </div>

              {/* Email Notification Section */}
              <div className="bg-[#F9FAFB] border-[#EAECF0] border-[1px] rounded-md mt-5 text-black">
                <div className="bg-[#F9FAFB] p-4 md:p-6 rounded-lg">
                  <h2 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">
                    {t("Email Notification")}
                  </h2>
                  <p className="text-[#475467] text-sm md:text-base mb-4 md:mb-6">
                    {t(`We will send you notifications to inform you of any updates and/or changes as events occur for you or your business in AWN. Select which notifications you want to receive below`)}:
                  </p>
                </div>

                <div className="divide-y divide-[#EAECF0]">
                  <div className="p-4 md:p-6 flex flex-col md:flex-row md:justify-between md:items-center gap-4">
                    <div className="flex-1">
                      <h2 className="text-lg md:text-xl font-semibold mb-2 md:mb-4">
                        {t("Communication Emails")}
                      </h2>
                      <p className="text-[#475467] text-sm md:text-base mb-4 md:mb-0">
                        {t("Receive email for messages, contracts, documents.")}
                      </p>
                    </div>
                    <button
                      onClick={() =>
                        setCommunicationEmails(!communicationEmails)
                      }
                      className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors ${
                        communicationEmails ? "bg-[#1A6D73]" : "bg-gray-500"
                      }`}
                    >
                      <div
                        className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform ${
                          communicationEmails
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </button>
                  </div>

                  <div className="p-4 md:p-6 flex flex-col md:flex-row md:justify-between md:items-center gap-4">
                    <div className="flex-1">
                      <h2 className="text-lg md:text-xl font-semibold mb-2 md:mb-4">
                        {t("Announcements & Updates")}
                      </h2>
                      <p className="text-[#475467] text-sm md:text-base mb-4 md:mb-0">
                        {t(`Receive email about service updates, Improvements & Tickets, etc.`)}
                      </p>
                    </div>
                    <button
                      onClick={() => setEmailAnnouncements(!emailAnnouncemnets)}
                      className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors ${
                        emailAnnouncemnets ? "bg-[#1A6D73]" : "bg-gray-500"
                      }`}
                    >
                      <div
                        className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform ${
                          emailAnnouncemnets ? "translate-x-6" : "translate-x-0"
                        }`}
                      ></div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountSettings;
